import { render, staticRenderFns } from "./orderLogModal.vue?vue&type=template&id=24094400&scoped=true&"
import script from "./orderLogModal.vue?vue&type=script&lang=js&"
export * from "./orderLogModal.vue?vue&type=script&lang=js&"
import style0 from "./orderLogModal.vue?vue&type=style&index=0&id=24094400&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24094400",
  null
  
)

export default component.exports